import { useCallback, useState } from "react";

const STORAGE_KEY = "home-browser-wide-mode";

function readStored(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(STORAGE_KEY) === "true";
}

/**
 * Opt-in wide layout for the browser section of the home / workspace detail
 * pages: off, the section shares the surface's 58rem reading column; on, it
 * stretches to the full page width (the greeting and composer stay in the
 * column either way). One global preference rather than per surface or tab —
 * it's a monitor-size choice, so it follows the user everywhere.
 */
export function useHomeWideMode(): [boolean, (wide: boolean) => void] {
  const [wide, setWideState] = useState(readStored);

  const setWide = useCallback((next: boolean) => {
    setWideState(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, String(next));
    }
  }, []);

  return [wide, setWide];
}
